import axios, { AxiosResponse } from "axios";
import { LicensesUrl } from "./AUrl";
import { LicenseResponse } from "./assign";

/*
The function to unassign a license from a user.

@jwt: The JWT of the user making the request.
@userId: The ID of the user losing the license.
@licenseKey: The license key being removed.

@returns: The ApiResponse from the unassign license endpoint.
*/
export async function unassignLicense(
    jwt: string,
    userId: number,
    licenseKey: string,
): Promise<LicenseResponse> {
    const url = new LicensesUrl().unassign;
    if (!jwt) {
        return { status: 401, error: "JWT has expired" };
    }

    let response: AxiosResponse<any>;
    try {
        response = await axios.post<LicenseResponse | string>(
            url,
            { user_id: userId, license_key: licenseKey },
            {
                headers: {
                    "Content-Type": "application/json",
                    token: jwt,
                },
                validateStatus: () => true, // Resolve promise for all HTTP status codes
            },
        );
    } catch (error) {
        return {
            status: 500,
            error: "Network or other error occurred",
        };
    }

    return response.status === 200
        ? { status: response.status, message: response.data as string }
        : { status: response.status, error: response.data as string };
}
